import Link from 'next/link'
import { ButtonHTMLAttributes, forwardRef } from 'react'

import { cn } from '@/app/utils'

import styles from './Button.module.css'
import { ButtonFilledWith, ButtonSizes, ButtonVariants } from './Button.types'

type Props = ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: ButtonVariants
  size?: ButtonSizes
  filledWith?: ButtonFilledWith
  fluid?: boolean
  loading?: boolean
  href?: string
}

export type AppButtonComponent = HTMLButtonElement | HTMLAnchorElement

const Button = forwardRef<AppButtonComponent, Props>(
  (
    {
      variant = 'primary',
      size = 'medium',
      filledWith = 'default',
      fluid,
      children,
      className,
      loading,
      href,
      ...props
    },
    ref
  ) => {
    const Component = (href ? Link : 'button') as any

    return (
      <Component
        ref={ref}
        href={href as string}
        className={cn(
          'relative flex items-center justify-center font-bold transition-colors text-16 after:content-none',
          styles[variant],
          styles[size],
          styles[filledWith],
          fluid && 'w-full',
          loading &&
            '!text-transparent after:absolute after:inset-0 after:flex after:items-center after:justify-center after:content-["Загружается..."] [&>*]:invisible',
          className
        )}
        disabled={loading || props.disabled}
        {...props}
      >
        {children}
      </Component>
    )
  }
)

Button.displayName = 'AppButton'

export default Button
